import apiClient from './client'

export const paymentHistory = {
  getByToken: () => apiClient.get('/payments/history'),
}
